import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { BASE_API_URL } from '@curbnturf/entities';
import { StatusFacade } from '@curbnturf/status/src/lib/status.facade';
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import { AuthFacade } from './+state/auth.facade';

export const unauthenticatedErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  const authFacade = inject(AuthFacade);
  const statusFacade = inject(StatusFacade);

  return next(request).pipe(
    catchError((err) => {
      if (
        err instanceof HttpErrorResponse &&
        err.status === 401 &&
        // we only log them out if the 401 is from our server
        err.url?.includes(BASE_API_URL)
      ) {
        statusFacade.loggedIn$.pipe(first()).subscribe((loggedIn) => {
          if (loggedIn) {
            authFacade.logout('You have been logged out by the server');
          }
        });

        return throwError('You have been logged out by the server');
      }

      /*const error =
          (err.error && err.error.message) ||
          err.statusText ||
          err.message ||
          'Error making connecting to server';*/
      return throwError(() => err);
    }),
  );
};
